<template>
    <div>
        <b-button @click="printMapToFile" variant="warning" pill>
            <i class="fa fa-picture-o" />
            <span class="btn-label ml-2">Xuất bản đồ dạng ảnh</span>
        </b-button>
        <b-button class="ml-2" @click="printMapToFile" variant="primary" pill>
            <i class="fa fa-print" />
            <span class="btn-label ml-2"> In/xuất bản đồ dạng PDF </span>
        </b-button>

        <!-- Map Element -->
        <l-map
            class="mt-2"
            style="height: 650px"
            :zoom="zoom"
            :center="center"
            ref="myMap"
            :options="{ zoomControl: false, gestureHandling: true, maxZoom: 18 }"
            gestureHandling
        >
            <l-control position="topright" class="leaflet-bar leaflet-control">
                <div class="geojson-type bg-white">
                    <div>
                        <b-dropdown
                            no-caret
                            dropleft
                            variant="link"
                            toggle-class="bg-transparent border-none text-left shadow-none text-decoration-none"
                            menu-class="bg-white border border-gray-500"
                        >
                            <template slot="button-content">
                                <i class="fa fa-bolt fa-lg mr-1 text-warning" />
                                <span class="text-dark font-weight-bold">Ngập lụt</span></template
                            >
                            <v-select
                                v-model="selectedThunderTime"
                                :options="listThunderData"
                                label="time"
                                placeholder="Chọn thời gian"
                                :clearable="false"
                                :closeOnSelect="false"
                            >
                                <template v-slot:option="option">
                                    {{ option.time | formatDateTime }}
                                </template>
                                <template v-slot:selected-option="{ time }">
                                    <span style="font-size: 12px">
                                        {{ time | formatDateTime }}
                                    </span>
                                </template>
                                <template v-slot:no-options="{ search, searching, loading }">
                                    Không có dữ liệu
                                </template>
                            </v-select>
                        </b-dropdown>
                    </div>

                    <div>
                        <b-dropdown
                            no-caret
                            dropleft
                            variant="link"
                            toggle-class="bg-transparent border-none text-left shadow-none text-decoration-none"
                            menu-class="bg-white border border-gray-500"
                        >
                            <template slot="button-content">
                                <i class="fa fa-file-code-o mr-2 text-dark" />
                                <span class="text-dark font-weight-bold"
                                    >Kịch bản ngập lụt</span
                                ></template
                            >
                            <v-select
                                v-model="selectedFloodScriptTime"
                                :options="listScriptFloodData"
                                label="time"
                                placeholder="Chọn thời gian"
                                :clearable="false"
                                :closeOnSelect="false"
                            >
                                <template v-slot:option="option">
                                    {{ option.time | formatDateTime }}
                                </template>
                                <template v-slot:selected-option="{ time }">
                                    <span style="font-size: 12px">
                                        {{ time | formatDateTime }}
                                    </span>
                                </template>
                                <template v-slot:no-options="{ search, searching, loading }">
                                    Không có dữ liệu
                                </template>
                            </v-select>
                        </b-dropdown>
                    </div>
                </div>
            </l-control>
            <l-control-zoom position="topright" :options="zoomOption" />
            <l-control position="topright">
                <div class="leaflet-bar">
                    <a
                        @click="refreshMapView"
                        title="Xem toàn cảnh"
                        role="button"
                        aria-label="Xem toàn cảnh"
                        ><i class="fa fa-arrows-alt fa-lg"
                    /></a>
                </div>
            </l-control>

            <l-geo-json
                v-if="geoJsonData"
                :geojson="geoJsonData"
                ref="geoJson"
                :options="options"
                :options-style="styleFunction"
            />

            <l-control position="topleft">
                <div class="info legend">
                    <div class="title">Mực nước (m)</div>
                    <div v-for="(item, index) in CONSTANTS.THUNDER_LEGEND_INFO" :key="index">
                        <i :style="`background:#${item.color}`"></i>{{ item.value }}
                    </div>
                </div>
            </l-control>
        </l-map>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import CONSTANTS from '../constants';
import BarChartHistory from '@/components/BarChartHistory';

import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

export default {
    components: {
        BarChartHistory
    },
    props: {
        showReportButton: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            zoom: 11,
            center: [21.274446, 107.267796],
            zoomOption: {
                zoomInTitle: 'Phóng to',
                zoomOutTitle: 'Thu nhỏ'
            },
            selectedThunderTime: null,
            selectedFloodScriptTime: null,
            listThunderData: [],
            CONSTANTS,
            listScriptFloodData: []
        };
    },
    async created() {
        this.listThunderData = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.CURRENT_THUNDER
        });
        this.listScriptFloodData = await this.getListGeoJson({
            type: CONSTANTS.GEOJSON_TYPE.SCRIPT_FLOOD
        });
    },
    async mounted() {
        await this.initGeoJson();
        await this.$nextTick();
        this.initMapControl();
    },
    computed: {
        ...mapState({
            geoJsonData: (state) => state.geojson.item,
            listStations: (state) => state.station.items,
            waterData: (state) => state.analyze.waterData,
            rainData: (state) => state.analyze.rainData
        }),
        options() {
            return {
                onEachFeature: this.onEachFeatureFunction
            };
        },
        styleFunction() {
            return (feature) => {
                const properties = feature.properties.value;
                return {
                    weight: 2,
                    opacity: 1,
                    color: 'transparent',
                    fillOpacity: 0.7,
                    fillColor: this.featureStyle(properties)
                };
            };
        },
        onEachFeatureFunction() {
            return (feature, layer) => {
                let properties = feature.properties.value;
                properties = properties ? parseInt(properties) : 0;
                const tooltipTitle = `Mực nước: ${properties} m`;
                layer.on({
                    click: this.zoomToFeature
                });
                layer.bindTooltip(`<div>${tooltipTitle}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureRegionGeojson() {
            this.listLabelProvine = L.layerGroup().addTo(this.$refs.myMap.mapObject);
            return (feature, layer) => {
                layer.on({
                    click: this.zoomToFeature
                });
                if (feature.properties && feature.properties.NAME_3) {
                    const label = L.marker(layer.getBounds().getCenter(), {
                        icon: L.divIcon({
                            className: 'region-label',
                            html: feature.properties.NAME_3,
                            iconSize: [100, 40]
                        })
                    }).addTo(this.$refs.myMap.mapObject);
                    label.addTo(this.listLabelProvine);
                }
            };
        },
        onEachFeatureVetLuGeojson() {
            return (feature, layer) => {
                layer.bindTooltip(`<div>${feature.properties.diachi}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureTranhLuGeojson() {
            return (feature, layer) => {
                layer.bindTooltip(`<div>Điểm tránh lũ tại ${feature.properties.ten}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureUBNDGeojson() {
            return (feature, layer) => {
                layer.bindTooltip(`<div>${feature.properties.Comune}</div>`, {
                    permanent: false,
                    sticky: true
                });
            };
        },
        onEachFeatureRoadGeojson() {
            return (feature, layer) => {
                layer.on({
                    click: this.zoomToFeature
                });
                if (feature.properties && feature.properties.ref) {
                    layer.bindTooltip(`<div>${feature.properties.ref}</div>`, {
                        permanent: false,
                        sticky: true
                    });
                }
            };
        }
    },
    watch: {
        selectedThunderTime(val) {
            if (val) {
                this.selectedFloodScriptTime = null;
                this.downGeoJson({ id: val.path });
            }
        },
        selectedFloodScriptTime(val) {
            if (val) {
                this.selectedThunderTime = null;
                this.downGeoJson({ id: val.path });
            }
        }
    },
    methods: {
        ...mapActions({
            getThunderData: 'station/getListStationWater',
            getListGeoJson: 'geojson/getList',
            downGeoJson: 'geojson/downGeoJson'
        }),
        ...mapMutations({
            setGeoJson: 'geojson/SET_GEOJSON'
        }),
        async initGeoJson() {
            // / Lớp nền đường phố
            const roadRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/BacheRoad.geojson'
            );
            this.roadGeojson = await roadRes.json();

            // / Lớp nền khu vực
            const regionRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/HanhChinh.geojson'
            );
            this.regionGeojson = await regionRes.json();

            // / Lớp nền địa hình
            const contourRes = await fetch(
                'https://api.canhbaolu.bache.vn/api/files/2020_11_26_05_46_42_Contour.geojson'
            );
            this.contourGeojson = await contourRes.json();

            // / Lớp nền vết lũ
            const vetLuRes = await fetch(
                'https://api.canhbaolu.bache.vn/api/geojson/2020_12_01_23_00_00_OTHER.geojson'
            );
            this.vetLuGeojson = await vetLuRes.json();

            // / Lớp nền tránh lũ
            const tranhLuRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/Vi_tri_tranh_lu_WGS84.geojson'
            );
            this.tranhLuGeojson = await tranhLuRes.json();

            // / Lớp nền UBND xã
            const UBNDXaRes = await fetch(
                'https://raw.githubusercontent.com/StorkNguyen97/geojson_ba_che_gis/main/UBNDXa.geojson'
            );
            this.UBNDGeojson = await UBNDXaRes.json();
        },
        initMapControl() {
            const map = this.$refs.myMap.mapObject;
            map.addControl(
                new L.Control.Search({
                    url: 'https://nominatim.openstreetmap.org/search?format=json&q={s}',
                    jsonpParam: 'json_callback',
                    propertyName: 'display_name',
                    propertyLoc: ['lat', 'lon'],
                    marker: L.circleMarker([0, 0], { radius: 100 }),
                    autoCollapse: true,
                    autoType: false,
                    minLength: 2
                })
            );

            // Bản đồ hành chính quốc gia
            const regionMap = L.tileLayer(
                `https://maps.vnpost.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=${CONSTANTS.VN_MAP_API_KEY}`,
                {
                    attribution:
                        'Powered by <a target="_blank" href="http://gis.chinhphu.vn/">Bản đồ số Việt Nam</a>'
                }
            ).addTo(map);

            const contourMap = L.tileLayer(
                `https://maps.vnpost.vn/api/tm/{z}/{x}/{y}@2x.png?apikey=${CONSTANTS.VN_MAP_API_KEY}`,
                {
                    attribution:
                        'Powered by <a target="_blank" href="http://gis.chinhphu.vn/">Bản đồ số Việt Nam</a>'
                }
            );

            const hybridMutant = L.tileLayer.bing({
                bingMapsKey: 'ArA6oVbF7ebYgOJee15IlWHGPsf7CMozhAk343Oi1HhfecgOrnlTSuYuaWaukkHa',
                imagerySet: 'AerialWithLabelsOnDemand',
                culture: 'vi-VN'
            });

            const roadMutant = L.tileLayer.bing({
                bingMapsKey: 'ArA6oVbF7ebYgOJee15IlWHGPsf7CMozhAk343Oi1HhfecgOrnlTSuYuaWaukkHa',
                imagerySet: 'RoadOnDemand',
                culture: 'vi-VN'
            });

            let regionGeojson = L.geoJSON(this.regionGeojson, {
                onEachFeature: this.onEachFeatureRegionGeojson,
                style: (feature) => {
                    return {
                        weight: 2,
                        opacity: 0.5,
                        fillColor: this.getColor(feature.properties.ID_3),
                        fillOpacity: 0.7
                    };
                }
            }).addTo(map);

            const roadLayer = L.geoJSON(this.roadGeojson, {
                style: {
                    weight: 1,
                    color: '#f3b623',
                    fillColor: '#feefc3'
                },
                onEachFeature: this.onEachFeatureRoadGeojson
            }).addTo(map);

            const contourGeojson = L.geoJSON(this.contourGeojson, {
                style: {
                    weight: 1
                }
            });

            const vetLuGeojson = L.geoJSON(this.vetLuGeojson, {
                pointToLayer: function (feature, latlng) {
                    return L.marker(latlng, {
                        icon: L.divIcon({
                            className: 'station-bg rainValueGather60',
                            html: `<div><span>${
                                feature.properties.caodovet_1
                                    ? parseInt(feature.properties.caodovet_1)
                                    : 0
                            }</span></div>`
                        })
                    });
                },
                onEachFeature: this.onEachFeatureVetLuGeojson
            });

            const tranhLuLayer = L.geoJSON(this.tranhLuGeojson, {
                pointToLayer: function (feature, latlng) {
                    return L.marker(latlng, {
                        icon: L.icon({
                            iconUrl: '/img/safety.png',
                            iconSize: [17, 17]
                        })
                    });
                },
                onEachFeature: this.onEachFeatureTranhLuGeojson
            }).addTo(map);

            L.geoJSON(this.UBNDGeojson, {
                pointToLayer: function (feature, latlng) {
                    return L.marker(latlng, {
                        icon: L.icon({
                            iconUrl: '/img/UBND.png',
                            iconSize: [23, 32]
                        })
                    });
                },
                onEachFeature: this.onEachFeatureUBNDGeojson
            }).addTo(map);

            const baseMap = {
                'Bản đồ hành chính': regionMap,
                'Bản đồ địa hình': contourMap,
                'Bing Map vệ tinh': hybridMutant,
                'Bing Map đường phố': roadMutant
            };

            const overlayMap = {
                'Bản đồ vết lũ huyện Ba Chẽ': vetLuGeojson,
                'Bản đồ đường tránh lũ huyện Ba Chẽ': roadLayer,
                'Bản đồ điểm tránh lũ huyện Ba Chẽ': tranhLuLayer
            };

            L.control
                .layers(baseMap, overlayMap, {
                    position: 'bottomleft'
                })
                .addTo(map);

            this.setUpPrintMap();
            // On Change map tiles Event
            map.on('baselayerchange', (e) => {
                if (e.name === 'Bản đồ hành chính') {
                    map.removeLayer(contourGeojson);
                    map.addLayer(regionGeojson);
                } else if (e.name === 'Bản đồ địa hình') {
                    map.removeLayer(regionGeojson);
                    map.addLayer(contourGeojson);
                } else {
                    map.removeLayer(regionGeojson);
                    map.removeLayer(contourGeojson);
                }
                this.tileLayerOption = e.name;
                this.setUpPrintMap();
            });
        },
        getColor(d) {
            switch (d) {
                case 8013:
                    return '#fec493';
                case 8014:
                    return '#ffc4c6';
                case 8015:
                    return '#fefd7e';
                case 8016:
                    return '#dcfdae';
                case 8017:
                    return '#d9affb';
                case 8018:
                    return '#8cf795';
                case 8019:
                    return '#d2aaab';
                case 8020:
                    return '#dcdb30';
            }
        },
        setUpPrintMap() {
            // BrowserPrint registerLayer
            if (this.tileLayerOption != 'Bản đồ số Việt Nam') {
                let typeMap = this.tileLayerOption === 'Google Map vệ tinh' ? 'hybrid' : 'roadmap';
                L.Control.BrowserPrint.Utils.registerLayer(
                    L.GridLayer.GoogleMutant,
                    'L.GridLayer.GoogleMutant',
                    (layer, utils) => {
                        return L.gridLayer.googleMutant({
                            maxZoom: 24,
                            type: typeMap,
                            attribution:
                                '&copy; <a target="_blank" href="https://www.google.com/permissions/geoguidelines/">Google Map</a> contributors'
                        });
                    }
                );
            }

            L.control
                .browserPrint({
                    documentTitle: 'Cảnh báo lũ',
                    printModes: [
                        L.control.browserPrint.mode(
                            L.Control.BrowserPrint.Mode.Landscape,
                            null,
                            null,
                            null,
                            true
                        )
                    ],
                    manualMode: false
                })
                .addTo(this.$refs.myMap.mapObject);
        },
        featureStyle(feature) {
            return feature > 4
                ? '#1a237e'
                : feature > 3.5
                ? '#283593'
                : feature > 3
                ? '#303f9f'
                : feature > 2.5
                ? '#3949ab'
                : feature > 2
                ? '#3f51b5'
                : feature > 1.5
                ? '#5c6bc0'
                : feature > 1
                ? '#7986cb'
                : feature > 0.5
                ? '#9fa8da'
                : feature > 0
                ? '#c5cae9'
                : '#D2D5EB';
        },
        zoomToFeature(e) {
            this.$refs.myMap.mapObject.fitBounds(e.target.getBounds());
        },
        refreshMapView() {
            this.$refs.myMap.mapObject.setView(this.center, this.zoom);
        },
        saveAsExcelFile(report, fileName) {
            const worksheet = XLSX.utils.json_to_sheet(report);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

            const data = new Blob([excelBuffer], { type: EXCEL_TYPE });
            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        },
        exportReportObject() {
            const report = [];
            for (let i = 0; i < this.listStations.length; i++) {
                const station = this.listStations[i];
                report.push({
                    STT: i + 1,
                    'Mã trạm': station.code,
                    'Tên trạm': station.name,
                    'Kinh độ': station.lat,
                    'Vĩ độ': station.long,
                    'Mô tả': station.description
                });
            }
            const excelFileName =
                'Báo cáo tổng hợp các đối tượng quanh khu vực ' +
                this.$moment().format('HH:mm:ss DD/MM/YYYY');
            this.saveAsExcelFile(report, excelFileName);
        },
        exportReportNumber() {
            const report = [];
            const waterMonthMap = _.groupBy(this.waterData, (item) => {
                return item.date.substring(3);
            });
            const rainMonthMap = _.groupBy(this.rainData, (item) => {
                return item.date.substring(3);
            });
            const months = _.uniq(_.concat(_.keys(waterMonthMap), _.keys(rainMonthMap)));
            for (let i = 0; i < months.length; i++) {
                const month = months[i];
                report.push({
                    STT: i + 1,
                    Tháng: month,
                    'Mực nước trung bình (m)': this.getWater(waterMonthMap, month),
                    'Lượng mưa (mm)': this.getRain(rainMonthMap, month)
                });
            }
            const excelFileName =
                'Báo cáo tổng hợp các số liệu ' + this.$moment().format('HH:mm:ss DD/MM/YYYY');
            this.saveAsExcelFile(report, excelFileName);
        },
        getWater(waterMonthMap, month) {
            try {
                return (
                    _.sumBy(waterMonthMap[month], 'value') /
                    waterMonthMap[month].length /
                    100
                ).toFixed(2);
            } catch (error) {
                return '';
            }
        },
        getRain(rainMonthMap, month) {
            try {
                return _.sumBy(rainMonthMap[month], 'value').toFixed(2);
            } catch (error) {
                return '';
            }
        },
        printMapToFile() {
            let modeToUse = L.control.browserPrint.mode.landscape();
            this.$refs.myMap.mapObject.printControl.print(modeToUse);
        }
    },
    beforeDestroy() {
        this.setGeoJson(null);
    }
};
</script>
<style lang="scss">
.geojson-type {
    color: black;
    margin-right: 0px !important;

    .nav-link {
        padding: 0.5rem 0.85rem !important;
        color: black;
    }

    button {
        padding: 0.45rem !important;
    }
}

.leaflet-control-search {
    .search-input {
        min-width: 150px;
    }
}
</style>
<style lang="scss" scoped>
.info {
    padding: 6px 8px;
    font: 14px/16px Arial, Helvetica, sans-serif;
    background: white;
    background: rgba(255, 255, 255, 0.8);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
    border-radius: 5px;

    .title {
        font-weight: 600;
        font-size: 16px;
        margin-bottom: 5px;
    }
}

.legend {
    text-align: left;
    line-height: 18px;

    i {
        width: 18px;
        height: 18px;
        float: left;
        margin-right: 8px;
        opacity: 0.7;
    }
}
</style>